import React from 'react';
import { Heart, Github, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-100 dark:bg-slate-900 py-8 px-6 border-t border-slate-200 dark:border-slate-800">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4">Chandana Vadathala</h3>
            <p className="text-slate-600 dark:text-slate-400">
              Computer Science undergraduate passionate about building impactful web applications.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4">Quick Links</h3>
            <div className="space-y-2">
              <a href="#home" className="block text-slate-600 dark:text-slate-400 hover:text-teal-500 transition-colors">
                Home
              </a>
              <a href="#about" className="block text-slate-600 dark:text-slate-400 hover:text-teal-500 transition-colors">
                About
              </a>
              <a href="#projects" className="block text-slate-600 dark:text-slate-400 hover:text-teal-500 transition-colors">
                Projects
              </a>
              <a href="#contact" className="block text-slate-600 dark:text-slate-400 hover:text-teal-500 transition-colors">
                Contact
              </a>
            </div>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4">Connect</h3>
            <div className="flex gap-4">
              <a
                href="https://github.com/chandanavadathala"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 rounded-full bg-slate-200 dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-teal-500 hover:text-white transition-all hover:scale-110"
              >
                <Github className="h-5 w-5" />
              </a>
              <a
                href="https://www.linkedin.com/in/chandana-vadathala-b7298a294"
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 rounded-full bg-slate-200 dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-teal-500 hover:text-white transition-all hover:scale-110"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href="mailto:chandanavadathala@gmail.com"
                className="p-3 rounded-full bg-slate-200 dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-teal-500 hover:text-white transition-all hover:scale-110"
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-200 dark:border-slate-800 pt-6">
          <p className="text-center text-slate-600 dark:text-slate-400 flex items-center justify-center gap-2">
            Made with <Heart className="h-4 w-4 text-red-500 fill-current" /> by Chandana Vadathala © {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
